import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24">
        <section className="section-padding">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Terms of Service
              </h1>
              <p className="text-muted-foreground mb-12">
                Last updated: January 2026
              </p>

              <div className="prose prose-invert max-w-none space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    By accessing or using ThumbGenius ("the Service"), you agree to be bound 
                    by these Terms of Service. If you do not agree to these terms, please do 
                    not use our service.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">2. Description of Service</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    ThumbGenius is an AI-powered platform that generates YouTube thumbnails 
                    based on user input. The service includes free and paid subscription tiers 
                    with varying features and generation limits.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">3. User Accounts</h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    To use certain features of the Service, you must create an account. You agree to:
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2">
                    <li>Provide accurate and complete information</li>
                    <li>Maintain the security of your account credentials</li>
                    <li>Notify us immediately of any unauthorized access</li>
                    <li>Be responsible for all activities under your account</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">4. Subscription and Payments</h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    Paid subscriptions are billed on a recurring basis. By subscribing, you agree to:
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2">
                    <li>Pay the applicable subscription fees</li>
                    <li>Automatic renewal unless cancelled before the billing date</li>
                    <li>No refunds for partial subscription periods (except within our 7-day guarantee)</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    <strong className="text-foreground">Your Content:</strong> You retain ownership of the 
                    video titles and descriptions you provide. You grant us a license to process this 
                    content to provide the Service.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong className="text-foreground">Generated Thumbnails:</strong> Thumbnails generated 
                    through our Service are yours to use. You receive full commercial rights to use them 
                    on your YouTube channel and other platforms.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">6. Acceptable Use</h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    You agree not to use the Service to:
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-2">
                    <li>Generate illegal, harmful, or offensive content</li>
                    <li>Infringe on the rights of others</li>
                    <li>Attempt to reverse engineer or hack our systems</li>
                    <li>Use automated systems to abuse the Service</li>
                    <li>Resell or redistribute the Service without permission</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">7. Disclaimer of Warranties</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    The Service is provided "as is" without warranties of any kind. We do not 
                    guarantee that thumbnails will increase your views or click-through rate. 
                    Results may vary based on many factors outside our control.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    To the maximum extent permitted by law, ThumbGenius shall not be liable 
                    for any indirect, incidental, special, or consequential damages arising 
                    from your use of the Service.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">9. Termination</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    We reserve the right to suspend or terminate your account at any time for 
                    violation of these terms. You may cancel your account at any time through 
                    your account settings.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">10. Changes to Terms</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    We may update these Terms from time to time. Continued use of the Service 
                    after changes constitutes acceptance of the new terms. We will notify users 
                    of material changes via email or in-app notification.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">11. Governing Law</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    These Terms shall be governed by and construed in accordance with the laws 
                    of the jurisdiction in which ThumbGenius operates, without regard to conflict 
                    of law provisions.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">12. Contact</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    For questions about these Terms, please contact us at{" "}
                    <a href="mailto:legal@thumbgenius.ai" className="text-primary hover:underline">
                      legal@thumbgenius.ai
                    </a>
                  </p>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
